import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = { options: Object, rawCounts: Array }

  connect() {
    if (this.element.children.length > 0) return

    const options = { ...this.optionsValue }
    if (this.hasRawCountsValue) {
      options.tooltip = {
        ...options.tooltip,
        y: {
          formatter: (value, opts) =>
            `${this.rawCountsValue[opts.seriesIndex][opts.dataPointIndex]} leads`
        }
      }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }

  disconnect() {
    this.chart?.destroy()
  }
}
